import { styled } from "@mui/material";

export const Divider = styled('div')(({ theme }) => ({
    width: '1px',
    height: '16px',
    background: theme.palette.neutralDarkGray.main,
}));
